import { useTheme } from '@emotion/react';
import * as React from 'react';
import { ICON_BADGE_ICON_SIZE_MAP } from './constants.js';
import { IconBadgeContainer } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const IconBadge = React.forwardRef(({
  icon,
  backgroundColor,
  color,
  size = 'md',
  ...props
}, ref) => {
  const {
    colorScheme
  } = useTheme();
  return jsx(IconBadgeContainer, {
    ref: ref,
    as: "div",
    size: size,
    backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : colorScheme.iconBadge.background.default,
    color: color !== null && color !== void 0 ? color : colorScheme.iconBadge.content.default,
    ...props,
    children: React.cloneElement(icon, {
      size: ICON_BADGE_ICON_SIZE_MAP[size],
      ...icon.props
    })
  });
});
IconBadge.displayName = 'IconBadge';

export { IconBadge };
